export const OPC_ENDPOINT = "opc.tcp://10.226.52.134:4840"

export const SIEMENS_BLUE = "#005AAB"

export interface StepConfig {
  label: string
  nodeId: string
}

export interface StationConfig {
  id: string
  label: string
  icon: string
  isActive: boolean
  steps: StepConfig[]
}

export const STATIONS: StationConfig[] = [
  {
    id: "conveyor",
    label: "Conveyor Station",
    icon: "conveyor",
    isActive: true,
    steps: [
      { label: "Tray present",              nodeId: 'ns=3;s="Tray_present"' },
      { label: "Conveyor started",           nodeId: 'ns=3;s="Conveyor_started"' },
      { label: "Stopper down",              nodeId: 'ns=3;s="Stopper_down"' },
      { label: "Tray identified (RFID)",    nodeId: 'ns=3;s="Tray_identified(RFID)"' },
      { label: "Tray at the pickup point",  nodeId: 'ns=3;s="Tray_at_the_pickup_point"' },
      { label: "Conveyor stopped",          nodeId: 'ns=3;s="Conveyor_stopped"' },
    ],
  },
  {
    id: "assembly",
    label: "Assembly Station",
    icon: "assembly",
    isActive: true,
    steps: [
      { label: "Part picked from the tray",               nodeId: 'ns=3;s="Part_picked_from_the_tray"' },
      { label: "Part placed between clamping cylinders",  nodeId: 'ns=3;s="Part_Placed_between_clamping_cylinders"' },
      { label: "Base Part clamped",                       nodeId: 'ns=3;s="Base_Part_clamped"' },
      { label: "Inspection done",                         nodeId: 'ns=3;s="Inspection_done"' },
      { label: "First part placed",                       nodeId: 'ns=3;s="First_part_placed"' },
      { label: "Second part placed",                      nodeId: 'ns=3;s="Second_part_placed"' },
      { label: "Screwing the parts",                      nodeId: 'ns=3;s="Parts_screwing"' },
      { label: "Screwing done",                           nodeId: 'ns=3;s="Done_screwing"' },
    ],
  },
  {
    id: "packaging",
    label: "Packaging Station",
    icon: "packaging",
    isActive: true,
    steps: [
      { label: "Part placed in the box",  nodeId: 'ns=3;s="Part_placed_in_the_box"' },
      { label: "Box picked by the robot", nodeId: 'ns=3;s="Box_picked_by_the_robot"' },
      { label: "Box flaps closed",        nodeId: 'ns=3;s="Box_flaps_closed"' },
      { label: "Taping done",             nodeId: 'ns=3;s="Taping_done"' },
      { label: "Printing done",           nodeId: 'ns=3;s="Printing_done"' },
    ],
  },
  {
    id: "testing",
    label: "Testing Station",
    icon: "testing",
    isActive: false,
    steps: [],
  },
  {
    id: "hexnut",
    label: "Hex Nut Assembly",
    icon: "hexnut",
    isActive: false,
    steps: [],
  },
]

export const SYSTEM_NODES = {
  power:              'ns=3;s="MPRC_power_on"',
  manualMode:         'ns=3;s="Manual_mode"',
  robotStatus:        'ns=3;s="robot_status"',
  toolChangerEngage:  'ns=3;s="Master_Tool_changer_Engage"',
  toolChangerDisengage: 'ns=3;s="Master_Tool_changer_Disengage"',
}

// KRC_Move tags — P2P_Part_Packing function block on Siemens PLC ↔ KUKA KRC4
export const ROBOT_MOVE_NODES = {
  posX:   'ns=3;s="P2P_Part_Packing"."KRC_Move"."Position"."X"',
  posY:   'ns=3;s="P2P_Part_Packing"."KRC_Move"."Position"."Y"',
  posZ:   'ns=3;s="P2P_Part_Packing"."KRC_Move"."Position"."Z"',
  posA:   'ns=3;s="P2P_Part_Packing"."KRC_Move"."Position"."A"',
  posB:   'ns=3;s="P2P_Part_Packing"."KRC_Move"."Position"."B"',
  posC:   'ns=3;s="P2P_Part_Packing"."KRC_Move"."Position"."C"',
  axisA1: 'ns=3;s="P2P_Part_Packing"."KRC_Move"."AxisPosition"."A1"',
  axisA2: 'ns=3;s="P2P_Part_Packing"."KRC_Move"."AxisPosition"."A2"',
  axisA3: 'ns=3;s="P2P_Part_Packing"."KRC_Move"."AxisPosition"."A3"',
  axisA4: 'ns=3;s="P2P_Part_Packing"."KRC_Move"."AxisPosition"."A4"',
  axisA5: 'ns=3;s="P2P_Part_Packing"."KRC_Move"."AxisPosition"."A5"',
  axisA6: 'ns=3;s="P2P_Part_Packing"."KRC_Move"."AxisPosition"."A6"',
  busy:     'ns=3;s="P2P_Part_Packing"."KRC_Move"."Busy"',
  active:   'ns=3;s="P2P_Part_Packing"."KRC_Move"."Active"',
  done:     'ns=3;s="P2P_Part_Packing"."KRC_Move"."Done"',
  error:    'ns=3;s="P2P_Part_Packing"."KRC_Move"."Error"',
  velocity: 'ns=3;s="P2P_Part_Packing"."KRC_Move"."Velocity"',
  moveType: 'ns=3;s="P2P_Part_Packing"."KRC_Move"."MoveType"',
}

export const ALL_NODE_IDS: string[] = [
  ...Object.values(SYSTEM_NODES),
  ...Object.values(ROBOT_MOVE_NODES),
  ...STATIONS.filter((s) => s.isActive).flatMap((s) => s.steps.map((step) => step.nodeId)),
]
